/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable max-len */
import al1 from '../image/readMore/artificialLawn/al1.jpeg'
import al2 from '../image/readMore/artificialLawn/al2.jpeg'
import al3 from '../image/readMore/artificialLawn/al3.jpeg'
import al4 from '../image/readMore/artificialLawn/al4.jpeg'
import gravelPath from '../image/readMore/compositeDecking/gravelPath.jpeg'
import foggyWhart from '../image/readMore/compositeDecking/foggyWhart.jpeg'
import islandMist from '../image/readMore/compositeDecking/islandMist.jpeg'
import clamShell from '../image/readMore/compositeDecking/clamShell.jpeg'
import calmWater from '../image/readMore/compositeDecking/calmWater.jpeg'
import spicedRum from '../image/readMore/compositeDecking/spicedRum.jpeg'
import saddle from '../image/readMore/compositeDecking/saddle.jpeg'
import rockyHarbour from '../image/readMore/compositeDecking/rockyHarbour.jpeg'
import lavaRock from '../image/readMore/compositeDecking/lavaRock.jpeg'
import toastedSand from '../image/readMore/compositeDecking/toastedSand.jpeg'
import tikkiTorch from '../image/readMore/compositeDecking/tikkiTorch.jpeg'
import dek1 from '../image/readMore/decking/dek1.jpeg'
import dek2 from '../image/readMore/decking/dek2.jpeg'
import dek3 from '../image/readMore/decking/dek3.jpeg'
import dek4 from '../image/readMore/decking/dek4.jpeg'
import Planting11 from '../image/Gallery/Planting/ef24d3b2.jpg'
import Planting12 from '../image/Gallery/Planting/xcvbnm.jpg'
import Planting13 from '../image/Gallery/Planting/liugty63365.jpg'
import Planting14 from '../image/Gallery/Planting/465ygtf56.jpg'
import Planting15 from '../image/Gallery/Planting/d6117bd67.jpg'
import Planting16 from '../image/Gallery/Planting/f75987y6.jpg'
import pf1 from '../image/readMore/panelFencing/pf1.jpeg'
import pf2 from '../image/readMore/panelFencing/pf2.jpeg'
import pf3 from '../image/readMore/panelFencing/pf3.jpeg'
import pf4 from '../image/readMore/panelFencing/pf4.jpeg'
import bf1 from '../image/readMore/battenFencing/bf1.jpeg'
import bf2 from '../image/readMore/battenFencing/bf2.jpeg'
import bf3 from '../image/readMore/battenFencing/bf3.jpeg'
import bf4 from '../image/readMore/battenFencing/bf4.jpeg'
import pav1 from '../image/readMore/paving/pav1.jpeg'
import pav2 from '../image/readMore/paving/pav2.jpeg'
import pav3 from '../image/readMore/paving/pav3.jpeg'

import pav5 from '../image/readMore/paving/pav5.jpeg'
import pav6 from '../image/readMore/paving/pav6.jpeg'
import pav7 from '../image/readMore/paving/pav7.jpg'
import pav8 from '../image/readMore/paving/pav8.jpg'
import pav9 from '../image/readMore/paving/pav9.jpg'
import pav10 from '../image/readMore/paving/pav10.jpg'
import bp1 from '../image/readMore/blockPaving/bp1.jpeg'
import bp2 from '../image/readMore/blockPaving/bp2.jpeg'
import bp3 from '../image/readMore/blockPaving/bp3.jpeg'
import bp4 from '../image/readMore/blockPaving/bp4.jpeg'
import bp5 from '../image/readMore/blockPaving/bp5.jpeg'
import dr1 from '../image/readMore/drainage/dr1.jpeg'
import dr2 from '../image/readMore/drainage/dr2.jpeg'
import dr3 from '../image/readMore/drainage/dr3.jpeg'
import dr4 from '../image/readMore/drainage/dr4.jpeg'
import dr5 from '../image/readMore/drainage/dr5.jpeg'
import dr6 from '../image/readMore/drainage/dr6.jpeg'
import dr7 from '../image/readMore/drainage/dr7.jpeg'
import dr8 from '../image/readMore/drainage/dr8.jpeg'
import land1 from '../image/readMore/landscapeArchitect/land1.jpg'
import land2 from '../image/readMore/landscapeArchitect/land2.jpg'
import land3 from '../image/readMore/landscapeArchitect/land3.jpg'
import land4 from '../image/readMore/landscapeArchitect/land4.jpg'
import raised1 from '../image/readMore/raisedBeds/raised1.jpg'

// Landscape Architect images
import landscapeArch1 from '../image/landscapeArchitect/1.jpg'
import landscapeArch2 from '../image/landscapeArchitect/2.jpg'
import landscapeArch3 from '../image/landscapeArchitect/3.jpg'
import landscapeArch4 from '../image/landscapeArchitect/4.jpg'
import landscapeArch5 from '../image/landscapeArchitect/5.jpg'
import landscapeArch6 from '../image/landscapeArchitect/6.jpg'
import landscapeArch7 from '../image/landscapeArchitect/7.jpg'
import landscapeArch8 from '../image/landscapeArchitect/8.jpg'
import landscapeArch9 from '../image/landscapeArchitect/9.jpg'
import landscapeArch10 from '../image/landscapeArchitect/10.jpg'
import landscapeArchProject1 from '../image/landscapeArchitect/Project1.jpg'
import landscapeArchProject5 from '../image/landscapeArchitect/Project5.jpg'
import landscapeArchProject6 from '../image/landscapeArchitect/Project6.jpg'
import raised2 from '../image/readMore/raisedBeds/raised2.jpg'
import raised3 from '../image/readMore/raisedBeds/raised3.jpg'
import raised4 from '../image/readMore/raisedBeds/raised4.jpg'
import brickwall1 from '../image/readMore/brickwall/brickwall1.jpg'
import brickwall2 from '../image/readMore/brickwall/brickwall2.jpg'
import brickwall3 from '../image/readMore/brickwall/brickwall3.jpg'
import brickwall4 from '../image/readMore/brickwall/brickwall4.jpg'
import brickwall5 from '../image/readMore/brickwall/brickwall5.jpg'
import gat1 from '../image/readMore/gates/gat1.jpeg'
import gat2 from '../image/readMore/gates/gat2.jpeg'
import gat3 from '../image/readMore/gates/gat3.jpeg'
import gat4 from '../image/readMore/gates/gat4.jpeg'
import gat5 from '../image/readMore/gates/gat5.jpeg'
import lighting1 from '../image/readMore/lighting/lighting1.jpg'
import lighting2 from '../image/readMore/lighting/lighting2.jpg'
import lighting3 from '../image/readMore/lighting/lighting3.jpg'
import lighting4 from '../image/readMore/lighting/lighting4.jpg'
import lighting5 from '../image/readMore/lighting/lighting5.jpg'
import lighting6 from '../image/readMore/lighting/lighting6.jpg'
import summer1 from '../image/readMore/summer/summer1.jpg'
import summer2 from '../image/readMore/summer/summer2.jpg'
import summer3 from '../image/readMore/summer/summer3.jpg'
import summer4 from '../image/readMore/summer/summer4.jpg'
import Ready4 from '../image/Gallery/WoodfordGreen/Ready4.jpg'
import Ready1 from '../image/Gallery/EastFinchley/Ready1.jpg'
import Read9 from '../image/Gallery/CrouchHill/Read9.jpg'
import Ready13 from '../image/Gallery/HadleyWood/Ready13.jpg'
import Ready2 from '../image/Gallery/Redbridge/Ready2.jpg'
import Ready from '../image/Gallery/Loughton/Ready1.jpg'
import Plan from '../image/Gallery/Planting/6b17713c.jpg'
import Read1 from '../image/Gallery/CrouchHill/Read1.jpg'
import Read2 from '../image/Gallery/CrouchHill/Read2.jpg'
import Read3 from '../image/Gallery/CrouchHill/Read3.jpg'
import room1 from '../image/Gallery/CrouchHill/room1.jpg'
import room2 from '../image/Gallery/CrouchHill/room2.jpg'
import room3 from '../image/Gallery/CrouchHill/room3.jpg'
import room4 from '../image/Gallery/CrouchHill/room4.jpg'

import gardenClearance from '../image/gardenClearance.jpg'
import lawnCare from '../image/lawnCare.jpg'
import pressureWashing from '../image/pressureWashing.jpg'
import trimming from '../image/trimming.jpg'

import mBefore1New from '../image/Gallery/MuswellHill/before1New.jpg'

import muswellHill from '../image/Gallery/MuswellHill/Project1.jpg'
import muswellHill1 from '../image/Gallery/1MuswellHill/1.JPG'
import palmersGreen1 from '../image/Gallery/palmersGreen/1.JPG'
import leinsterRoad1 from '../image/Gallery/leinsterRoadMuswellHill/1.JPG'
import highbury1 from '../image/Gallery/Highbury/1.JPG'
import hampstead1 from '../image/Gallery/hampsteadSububanArea/1.JPG'
import hackney1 from '../image/Gallery/Hackney/1.JPG'
import belsizePark1 from '../image/Gallery/belsizePark/1.JPG'
import muswellHill4_1 from '../image/Gallery/4MuswellHill/1.jpg'
import muswellHill2_1 from '../image/Gallery/2MuswellHill/1.JPG'
import muswellHill3_1 from '../image/Gallery/3MuswellHill/1.JPG'
import hackney2_1 from '../image/Gallery/2Hackney/1.JPG'

// Resin images
import resin1 from '../image/Resin/1.jpg'
import resin2 from '../image/Resin/2.jpg'
import resin3 from '../image/Resin/3.jpg'
import resin4 from '../image/Resin/4.jpg'
import resin5 from '../image/Resin/5.jpg'
import resin6 from '../image/Resin/6.jpg'
import resin7 from '../image/Resin/7.jpg'
import resin8 from '../image/Resin/8.jpg'
import resin9 from '../image/Resin/9.jpg'
import resin10 from '../image/Resin/10.jpg'
import resin11 from '../image/Resin/11.jpg'
import resin12 from '../image/Resin/12.jpg'

export const landscapingJobs = {
  left: [
    { name: 'Planting Flowers and Trees', slug: 'planting-flowers-and-trees',type: 'L' },
    { name: 'Fence Installation', slug: 'fence-installation', type: 'L' },
    { name: 'Artificial Lawn', slug: 'artificial-lawn', type: 'L' },
    { name: 'Composite Decking', slug: 'composite-decking', type: 'L' },
    { name: 'Decking', slug: 'decking', type: 'L' },
    { name: 'Batten Fencing Softwood', slug: 'batten-fencing-softwood', type: 'L' },
    { name: 'Paving', slug: 'paving', type: 'L' },
    { name: 'Block Paving/Driveways',slug: 'block-paving-driveways', type: 'L' },
  ],
  right: [
    { name: 'Drainage', slug: 'drainage', type: 'L' },
    { name: 'Gates', slug: 'gates', type: 'L' },
    { name: 'Lighting', slug: 'lighting', type: 'L' },
    { name: 'Garden Room', slug: 'garden-room', type: 'L' },
    { name: 'Raised Beds', slug: 'raised-beds',type: 'L' },
    { name: 'Brickwall', slug: 'brickwall', type: 'L' },
    { name: 'Landscape Architect', slug: 'landscape-architect', type: 'L' },
    { name: 'Bonded Resin Gravel', slug: 'bonded-resin-gravel', type: 'L' },
  ],
}
export const jobs = [
  [
    { name: 'Landscaping', slug: 'landscaping', type: 'L' },
    { name: 'Planting Flowers and Trees', slug: 'planting-flowers-and-trees',type: 'L' },
    { name: 'Fence Installation', slug: 'fence-installation',type: 'L' },
    { name: 'Artificial Lawn', slug: 'artificial-lawn',type: 'L' },
    { name: 'Composite Decking', slug: 'composite-decking', type: 'L' },
    { name: 'Decking',slug: 'decking', type: 'L' },
    { name: 'Batten Fencing Softwood', slug: 'batten-fencing-softwood',type: 'L' },
    { name: 'Paving', slug: 'paving',type: 'L' },
    { name: 'Block Paving/Driveways',slug: 'block-paving-driveways', type: 'L' },
    { name: 'Drainage', slug: 'drainage', type: 'L' },
    { name: 'Gates' , slug: 'gates',type: 'L' },
    { name: 'Lighting', slug: 'lighting', type: 'L' },
    { name: 'Garden Room', slug: 'garden-room', type: 'L' },
    { name: 'Raised Beds', slug: 'raised-beds',type: 'L' },
    { name: 'Brickwall', slug: 'brickwall',type: 'L' },
    { name: 'Landscape Architect', slug: 'landscape-architect', type: 'L' },
    { name: 'Bonded Resin Gravel', slug: 'bonded-resin-gravel', type: 'L' },
  ],
  [
    { name: 'Garden Clearance', slug: 'garden-clearance' },
    { name: 'Lawn Care', slug: 'lawn-care' },
    { name: 'Pressure Washing', slug: 'pressure-washing' },
    { name: 'Bush and Tree Trimming', slug: 'bush-and-tree-trimming' },
  ],

]

export const aboutJobs = {
  'Landscaping': {
    type: 'L',
    category: false,
    isLandscaping: true,
    description: <>
      <strong>Landscaping in London – Beautiful Gardens, Built with Care</strong>
      <p>Turn your outdoor space into something truly special with our expert <b>landscaping services in London</b>. Whether you want a peaceful retreat, a family-friendly garden, or a modern space for entertaining, we design and build gardens that suit your lifestyle and enhance your home.<br /><br /></p>

      <strong>When and Why Do You Need Landscaping?</strong>
      <h4>You may want landscaping when:</h4>
      <ul>
        <li>Your garden feels overgrown, unorganised, or dull</li>
        <li>You`ve moved into a new home and want to redesign the outdoor area</li>
        <li>You need a safer, more practical space for children or pets</li>
        <li>You`re planning to sell or rent out your property and want to improve <b>kerb appeal</b></li>
        <li>You want to enjoy your garden more — with a patio, lawn, or relaxing area</li>
      </ul>
      <p>Whether it`s a small courtyard or a large garden, good landscaping adds real quality to your life and property.<br /><br /></p>

      <strong>What You Gain with Our Landscaping Service</strong>
      <ul>
        <li><b>A garden made for you</b> – Designed around your style, space and lifestyle</li>
        <li><b>Increased property value</b> – A well-landscaped garden boosts the appeal of any home</li>
        <li><b>Year-round enjoyment</b> – From sunny BBQs to quiet evenings outdoors</li>
        <li><b>Low-maintenance options</b> – Enjoy your garden without constant upkeep</li>
        <li><b>Professional finish</b> – Clean lines, clever planting, and durable materials<br /><br /></li>
      </ul>

      <strong>Why Choose Us?</strong>
      <p>We`re trusted providers of <b>garden landscaping in London</b>, known for quality work, great communication, and attention to detail. Our team offers:</p>
      <ul>
        <li>Free consultation and garden planning advice</li>
        <li>Creative ideas matched to your budget</li>
        <li>Skilled construction and planting</li>
        <li>Full clean-up and aftercare guidance</li>
      </ul>
      <p>We take care of everything — from the first sketch to the final paving stone — so you can simply enjoy the garden you`ve always wanted.<br /><br /></p>
    </>,
  },

  'Bonded Resin Gravel': {
    type: 'L',
    category: false,
    // TODO Price??
    //price: <>Price form per Sq.m: <strong>£180</strong></>,
    description: <>
      <strong>Bonded Resin Gravel in London – Strong, Smooth & Stylish Surfacing</strong>
      <p>Upgrade your driveway, paths, or patios with <b>bonded resin gravel</b> — a modern, low-maintenance surface that`s both beautiful and built to last. As experienced installers of resin <b> bound driveways in London</b>, we deliver smooth, hard-wearing finishes that enhance any home or outdoor space.<br /><br /></p>

      <strong>What Is Bonded Resin Gravel?</strong>
      <p><b>Bonded resin gravel</b> is a decorative surfacing system where natural stone is fixed in place with a strong, clear resin. It creates a seamless, flat surface that is both <b>durable and visually attractive</b>. It`s often used for <b>driveways, footpaths, patios, courtyards,</b> and <b>commercial spaces.</b><br /><br /></p>

      <p>We offer both <b>resin bonded</b> and <b>resin bound</b> options:</p>
      <ul>
        <li><b>Resin bound:</b> fully mixed with resin before laying, creating a smooth, porous surface (SUDS compliant)</li>
        <li><b>Resin bonded:</b> resin is laid first, and stone is scattered on top for a textured finish</li>
      </ul>
      <p>Both options are slip-resistant, long-lasting, and visually stunning.<br /><br /></p>

      <strong>When and Why Should You Choose Resin Gravel?</strong>
      <h4>Resin gravel is perfect when:</h4>
      <ul>
        <li>You want a clean, modern alternative to tarmac, block paving, or gravel</li>
        <li>You`re tired of weeds, puddles, or loose stones</li>
        <li>You want a durable surface that still looks natural and elegant</li>
        <li>You need a <b>permeable</b> solution to meet drainage or SUDS regulations</li>
        <li>You want a surface that requires very little maintenance</li>
      </ul>
      <p>Ideal for homes, businesses, schools, car parks, and gardens — especially in busy urban areas like London.<br /><br /></p>

      <strong>Benefits of Our Resin Gravel Installation</strong>
      <ul>
        <li> Attractive finish – Natural stone look with a range of colours and textures</li>
        <li> Weed & slip-resistant – Safe, tidy, and low-maintenance surface</li>
        <li> Long-lasting durability – Withstands heavy use and all types of weather</li>
        <li> Fast drainage – Water flows through the surface, helping avoid puddles</li>
        <li> Low maintenance – No loose stones, minimal cleaning needed</li>
        <li> Custom design – Choose colours, shapes, borders, and patterns<br /><br /></li>
      </ul>

      <strong>Why Choose Us?</strong>
      <p>As specialists in <b>resin bound surfacing in London</b>, we provide:</p>
      <ul>
        <li>Free site survey and advice</li>
        <li>A wide range of resin and stone combinations</li>
        <li>Professional ground preparation for strength and drainage</li>
        <li>Neat, fast, and guaranteed installation</li>
        <li>Honest pricing and long-term performance<br /><br /></li>
      </ul>
      <p>Whether you need a resin driveway, a garden path, or a complete outdoor makeover, we`re here to help you get a surface that`s not just practical — but also adds real style to your home or business.<br /><br /></p>

      <h4>Contact us today for a free quote on bonded resin gravel installation in London!<br />
      Strong, smooth, and stunning — it`s the smart way to resurface.</h4>
    </>,
    images: [resin1, resin2, resin3, resin4, resin5, resin6, resin7, resin8, resin9, resin10, resin11, resin12],

  },
  'Artificial Lawn': {
    category: false,
    type: 'L',
    price: <>Price from per Sq.m:  <strong>£210</strong></>,
    description: <><strong style={{ color: '#FF8B1F' }}>Area Suitability</strong>
      – This product is suitable for schools, gardens, balconies. pool surrounds, play areas and indoor areas. <br />
      <strong style={{ color: '#FF8B1F', marginTop: '10px', display: 'inline-block' }}>Size Options</strong>
      – Available in 2m or 4m widths and up to 25m in length</>,

    imgFirst: <img width='100%' src={al1} />,
    imgSecondary: <img width='100%' src={al2} />,
    imgThird: <img width='100%' src={al3} />,
    imgFourth: <img width='100%' src={al4} />,
    list: [
      { title: 'Child Friendly', icon: undefined },
      { title: 'Pet Friendly', icon: undefined },
      { title: 'Looks great all Seasons', icon: undefined },
      { title: 'High UV Stabilisation', icon: undefined },
      { title: 'NO More Mowing', icon: undefined },
      { title: 'No More Muddy Feet / Paws', icon: undefined },
      { title: 'Natural Grass look', icon: undefined },
      { title: 'Cut to size and easy to shape', icon: undefined },
      { title: 'Certified to BS EN1177', icon: undefined },
      { title: 'Certified to BS7044', icon: undefined },
      { title: '10 Year Guarantee', icon: undefined },
      { title: 'No More Watering / Feeding', icon: undefined },
      { title: 'Certified to BS 4790', icon: undefined },
    ],
  },
  'Composite Decking': {
    type: 'L',
    category: false,
    description: <>
      <span>GROOVED EDGE BOARD</span> <br /><br />
      <strong>Actual dimensions:</strong> <br /><br />
      <div className='point' /> 82 in x 5.5 in x 12 ft (20 mm x 140 mm x 365 cm)<br /><br />
      <div className='point' /> 82 in x 5.5 in x 16 ft (20 mm x 140 mm x 487 cm)<br /><br />
      <div className='point' /> 82 in x 5.5 in x 20 ft (20 mm x 140 mm x 609 cm)<br /><br />
       Our grooved edge boards install with our Hidden Fastening System beneath the deck surface, leaving a tidy finish free of screw holes.
    </>,
    palette: [
      { title: 'Gravel Path', icon: gravelPath },
      { title: 'Foggy Wharf', icon: foggyWhart },
      { title: 'Island Mist', icon: islandMist },
      { title: 'Clam Shell', icon: clamShell },
      { title: 'Calm Water', icon: calmWater },
      { title: 'Spiced Rum', icon: spicedRum },
      { title: 'Saddle', icon: saddle },
      { title: 'Rocky Harbour', icon: rockyHarbour },
      { title: 'Lava Rock', icon: lavaRock },
      { title: 'Toasted Sand', icon: toastedSand },
      { title: 'Tikki Torch', icon: tikkiTorch },

    ],
    price: <span>Price from per Sq.m: <strong>£400</strong></span>,
  },
  'Decking': {
    type: 'L',
    category: true,
    categoryContent: [
      {
        title:'Softwood Decking',
        list: ['Time of usage:  up to 10 years', 'Threated Frame:  6x2 timber'],
        price: <span>Price from per Sq.m:<strong>£220</strong></span>,
        img: dek1,
      },
      {
        title: 'Hardwood Decking',
        list: ['Time of usage:  up to 25 years', 'Threated Frame:  6x2 timber'],
        price: <span>Price from per Sq.m: <strong>£340</strong></span>,
        img: dek2,
      },
      {
        title: 'Softwood Decking Stained',
        list: ['Time of usage:  up to 15 years', 'Threated Frame:  6x2 timber'],
        price: <span>Price from per Sq.m:<strong>£250</strong></span>,
        img: dek3,
      },
      {
        title: 'Decking Maintenance',
        list: ['Jet Wash of the Deck', 'Anti Slippery Decking Stain', 'Painting', 'Minimum Charge 10m2'],
        price: <span>Price from per Sq.m:<strong>£60</strong></span>,
        img: dek4,
      },
    ],
  },
  'Lawn Care': {
    isHiddenTitle: true,
    category: false,
    description:<div className='jobContentDescription'><span className='pageDesc'><strong>Why Lawn Mowing is Important</strong> <br /><br />

    Keeping your lawn neatly mowed isn&apos;t just about appearance — it&apos;s about creating a healthy and enjoyable outdoor space. Regular mowing helps grass grow evenly, making your lawn look smooth and clean. It also keeps weeds and pests under control, improving the overall health of your garden.<br /><br />
    A well-maintained lawn adds value to your property and creates a pleasant space for family gatherings, barbecues, or simply relaxing outdoors. A freshly cut lawn shows you care for your home and makes a great impression on visitors or neighbours.<br /><br />
      Investing in professional lawn mowing saves you time and effort while ensuring your garden always looks its best. It&apos;s an easy way to enjoy a green, healthy, and beautiful outdoor space year-round.</span><div className='descImg' ><img src={lawnCare} /></div></div>,
    priceTitle: <span className='priceTitle'>For the price please contact us</span>,
  },
  'Garden Clearance': {
    isHiddenTitle: true,
    category: false,
    description: <div className='jobContentDescription'>
      <span className='pageDesc'>  <strong>Garden Cleaning is so easy with us </strong> <br /><br />
      A clean and tidy garden is not only more beautiful but also healthier. Regular garden cleaning removes fallen leaves, weeds, and debris that can attract pests or harm your plants. It helps your garden grow better and stay vibrant all year round.<br /><br />
      A well-maintained garden creates a welcoming space to relax or entertain guests. It adds value to your home and makes it more enjoyable to spend time outdoors. Plus, cleaning up your garden prepares it for the next season, whether it&apos;s planting flowers, enjoying summer evenings, or getting ready for winter.<br /><br />
      Hiring a professional saves you time and ensures the job is done thoroughly. You can enjoy the beauty of your garden without the hassle of doing it yourself.
      </span> <div className='descImg'><img src={gardenClearance} /></div></div>,
    titleList: <span className='priceTitle'>Garden clean up includes:</span>,
    list: [
      { title: 'Leaf clearance', icon: undefined },
      { title: 'Removal of weeds and all kinds of bramble', icon: undefined },
      { title: 'Trimming and cutting back hedges', icon: undefined },
      { title: 'Pruning or complete removal of bushes, trees, and ivy', icon: undefined },
      { title: 'Lawn mowing', icon: undefined },
      { title: 'Removal of broken fence panels or other garden garbage', icon: undefined },
    ],
    priceTitle: <span className='priceTitle'>For the price please contact us</span>,
  },
  'Pressure Washing': {
    isHiddenTitle: true,
    category: false,
    description:<div className='jobContentDescription'> <span className='pageDesc'><strong>After Pressure Washing everything looks like new!</strong> <br /><br />

    Pressure washing is the perfect way to make your outdoor spaces look like new again. It removes dirt, mold, and stains from surfaces like driveways, patios, walls, and fences. Regular cleaning keeps these areas in great condition and prevents long-term damage caused by grime or algae.<br /><br />
    Pressure washing improves the appearance of your property, making it look fresh and well-maintained. It&apos;s also a practical way to increase your home&apos;s curb appeal if you&apos;re planning to sell. Plus, it creates a cleaner, safer environment by removing slippery surfaces caused by moss or dirt buildup.<br /><br />
      Let professionals handle the hard work for you. Pressure washing is quick, effective, and a great way to protect your property and keep it looking its best.</span><div className='descImg'><img src={pressureWashing} /></div></div>,
    priceTitle: <span className='priceTitle'>For the price please contact us</span>,
  },
  'Bush and Tree Trimming': {
    isHiddenTitle: true,
    category: false,
    description:<div className='jobContentDescription'><span className='pageDesc'><strong>Why Bush and Tree Trimming is Important</strong> <br /><br />

    Trimming bushes and trees isn&apos;t just about keeping your garden tidy — it&apos;s essential for their health and growth. Regular trimming removes dead or overgrown branches, helping plants grow stronger and look more beautiful. It also allows sunlight to reach lower branches and improves air circulation, keeping your plants healthy.<br /><br />
    Well-maintained trees and bushes make your garden look neat and inviting. They can also prevent problems like falling branches or overgrown plants blocking pathways or windows. Professional trimming keeps your outdoor space safe, organized, and adds value to your property.<br /><br />
      Leave it to the experts to give your garden the perfect look. Professional bush and tree trimming saves you time and effort while ensuring your plants stay healthy and beautiful year-round.</span><div className='descImg'><img src={trimming} /></div></div>,
    priceTitle: <span className='priceTitle'>For the price please contact us</span>,
  },
  'Fence Installation' : {
    category: true,
    type: 'L',
    listCategory: {
      list: [
        { title:'Wooden Post/Gravel Board' ,
          list:['Time of usage:  up to 15 years','Threated Post:  4x4','Type: Closeboard Panel'],
          price: <span>Price from per Panel: <strong>£325 </strong></span>,
          img: pf1,
        },
        { title:'Wooden Post/Gravel Board',
          list: ['Time of usage:  up to 20 years','Threated Slatted Post:  4x4','Type: Cedar Horizontal Panel'],
          price: <span>Price from per Panel:<strong>£720</strong></span> ,
          img: pf2,
        },
        { title:'Concrete Post/Gravel Board',
          list: ['Time of usage:  up to 30 years,panels up to 15 years','Concrete Slatted Post:  4x4','Type: Closeboard Panel'],
          price: <span>Price from per Panel:<strong>£400 </strong></span> ,
          img: pf3,
        },
        { title:'Concrete Post/Gravel Board' ,
          list: ['Time of usage:  up to 25 years','Concrete Slatted Post:  4x4', 'Type: Cedar Horizontal Panel'],
          price:<span>Price from per Panel: <strong>£900</strong></span> ,
          img: pf4,
        }],
      description: <div className='descriptionContainer'>
        <strong>Fence Installation in London – Secure, Stylish, and Built to Last</strong>
        <p>Need a strong, attractive fence around your property? Our <b>professional fence installation services in London</b> are perfect for homeowners, landlords, and businesses looking to improve security, privacy, and the overall look of their outdoor space.<br /><br /></p>

        <strong>What Is Fence Installation?</strong>
        <p><b>Fence installation</b> involves setting up a physical barrier — usually made of wood, metal, or composite materials — around a garden, driveway, or boundary. It protects your property, marks borders, reduces noise, and enhances visual appeal. Whether you need <b>garden fencing, wooden fences,</b> or <b>security fencing,</b> we offer tailored solutions to suit your needs.<br /><br /></p>

        <strong>When and Why Do You Need a Fence?</strong>
        <h4>You might need a new fence if:</h4>
        <ul>
          <li>Your existing fence is damaged, leaning, or falling apart</li>
          <li>You`ve recently moved in and want more <b>privacy or security</b></li>
          <li>You want to create clear <b>boundaries</b> between you and your neighbours</li>
          <li>You`re upgrading your garden and want a fresh, clean look</li>
        </ul>
        <p>Fencing is ideal for private homes, rental properties, commercial premises, and gardens of any size.<br /><br /></p>

        <strong>What You Get with Our Fence Installation Service</strong>
        <ul>
          <li> <b>Security & privacy</b> – Keep your property safe from intruders and shield your garden from view.</li>
          <li> <b>Boosted kerb appeal</b> – A neat, well-installed fence instantly improves the look of your home or garden.</li>
          <li> <b>Increased property value</b> – Fences are a desirable feature for many buyers and tenants.</li>
          <li> <b>Protection from wind & noise</b> – Especially helpful in busy areas of London.</li>
          <li> <b>Custom design options</b> – Choose from different styles, materials, heights, and finishes.<br /><br /></li>
        </ul>

        <strong>Why Choose Us?</strong>
        <p>As experienced <b>fence contractors in London</b>, we provide quality craftsmanship, honest pricing, and reliable service from start to finish. We offer:</p>
        <ul>
          <li>Strong, weather-resistant materials (<b>including treated timber, closeboard, lap panels,</b> and <b>decorative fences</b>)</li>
          <li>Expert advice on the best fencing for your space and budget</li>
          <li>Fast and tidy installation with full clean-up</li>
        </ul>
        <p>Whether you need a classic wooden fence, a modern panel design, or secure fencing for a business, we`ll help you create the perfect boundary — both practical and attractive.<br /><br /></p>

        <h4>Get in touch now for a free quote on your fence installation in London!<br />
        Your garden or property boundary deserves a fence that`s built to last — and we`re here to deliver exactly that. <br /><br /></h4>
      </div>,
    },
  },
  'Batten Fencing Softwood': {
    category: true,
    categoryContent: [
      {
        title: 'Price from per Panel  (1.9m):',
        list: [
          <>Height 5 – 6ft (1.52-1.83m) - <strong>£420</strong></>,
          <>Height 3 – 4ft (0.91-1.52m) - <strong>£380</strong></>,
          <>Height till  3ft ( till 0.91m) - <strong>£320</strong></>,
        ],
        doubleImg: [bf1, bf2],
        tag: true,
      },
      {
        title: 'Price from per Panel  (1.9m):',
        list: [
          <>Height 5 – 6ft (1.52-1.83m) - <strong>£500</strong></>,
          <>Height 3 – 4ft (0.91-1.52m) - <strong>£430</strong></>,
          <>Height till  3ft ( till 0.91m) - <strong>£370</strong></>,
        ],
        doubleImg: [bf3, bf4],
        tag: true,
      },
    ],
  },
  'Paving': {
    type: 'L',
    category: false,
    price: <> Price from per Sq.m: <strong>£220 </strong></>,
    description: <>
      <strong>Paving Services in London – Durable, Stylish & Professional</strong>
      <p>Looking for <b>professional paving services in London?</b> Whether you need a new driveway, patio, garden path, or front entrance, our expert team is here to deliver top-quality results that combine durability with beautiful design.<br /><br /></p>

      <strong>What is Paving?</strong>

      <p>Paving is the process of laying solid materials — such as block paving, slabs, or stone — on flat surfaces to create strong, attractive walkways or driveways. It`s ideal for both residential and commercial properties. From <b>driveway paving</b> to <b>patio paving</b>, this service helps create clean, practical outdoor areas that are easy to use and maintain.<br /><br /></p>

      <strong>When and Why Do You Need Paving?</strong>
      <h4>You may need paving when:</h4>
      <ul>
        <li>Your current driveway or patio is cracked, uneven or looks worn out</li>
        <li>You want to replace gravel or muddy surfaces with something neater and long-lasting</li>
        <li>You`re renovating your home and want to boost <b>kerb appeal</b></li>
        <li>You want to make your outdoor space more functional and stylish<br /><br /></li>
      </ul>
      <p>Paving is suitable for homeowners, landlords, property managers, and even small businesses in London looking to upgrade their outdoor spaces.<br /><br /></p>

      <strong>What You Gain from Our Paving Service</strong>
      <ul>
        <li> <b>Improved appearance</b> – A professionally paved driveway or patio adds instant beauty to your home.</li>
        <li><b>Long-lasting durability</b> – High-quality materials and skilled installation ensure years of use with minimal maintenance.</li>
        <li> <b>Increased property value</b> – Well-paved outdoor spaces are a great investment that pays off if you sell your property.</li>
        <li> <b>Low maintenance </b>– No more weeds, mud, or mess – just clean, level surfaces all year round.</li>
        <li> <b>Safe and functional space</b> – Reduce trip hazards and enjoy smooth access to your home or garden.<br /><br /></li>
      </ul>

      <strong>Why Choose Us?</strong>
      <p>We`re trusted <b>paving contractors in London</b>, known for our reliable service, attention to detail, and honest pricing. Whether it`s a small path or a full garden transformation, we work with care, speed, and precision.<br /><br /></p>
    </>,
    images: [pav1, pav2, pav3, pav5, pav6,pav7, pav8, pav9, pav10],
  },
  'Block Paving/Driveways': {
    type: 'L',
    category: true,
    categoryContent: [
      {
        title: 'Block Paving',
        list: ['Concrete Base Minimum 150mm', 'Any Pattern'],
        price: <span>Price from per Sq.m: <strong>£260 </strong></span>,
        doubleImg: [bp4, bp3],
      },
      {
        title: 'Block Paving Driveway',
        list: ['Concrete Base Minimum 200mm', 'Reinforced Steel Mesh', 'Any Pattern'],
        price: <span>Price from per Sq.m: <strong>£300</strong></span>,
        doubleImg: [bp2, bp5],
      },
    ],
    lastImg: bp1,
  },
  'Drainage': {
    type: 'L',
    category: true,
    categoryContent: [
      { title:'Drainage point',
        list: ['Materials and Labour'],
        price: <span>Price from per Point: <strong>£150 </strong></span>,
        doubleImg: [dr2, dr1],
      },
      { title:'Drainage Channel',
        list: ['Materials and Labour'],
        price: <span>Price from per Linear m.: <strong>£150 </strong></span>,
        doubleImg: [dr3, dr4],
      },
      { title:'Paved Manhole',
        list: ['Materials and Labour'],
        price: <span>Price from per Point: <strong>£800</strong></span>,
        doubleImg: [dr5, dr6],
      },
      { title:'Water Stop Tap Cover',
        list: ['Materials and Labour'],
        price:<span>Price from per Point: <strong>£120 </strong></span>,
        doubleImg: [dr7, dr8],
      },
    ],
  },
  'Gates': {
    type: 'L',
    category: true,
    categoryContent: [
      { title: 'Metal Gates',
        text:'Time of usage:  up to 15 years',
        subtitle: 'Included:',
        list: ['Metal Gates','Labour'],
        price:<span>Price from : <strong>£375</strong></span> ,
        img: gat4,

      },
      { title: 'Metal Driveway Gates',
        text:'Time of usage:  up to 15 years',
        subtitle: 'Included:',
        list: ['Metal Gates','Labour' ],
        price:<span> Price from : <strong>£700</strong></span> ,
        img: gat5,
      },
      { title: 'Security Wooden Gate',
        text:'Time of usage:  up to 15 years',
        subtitle: 'Included:',
        list: ['Wooden Door','Hinges and handle','Long Throw lock','Labour' ],
        price: <span> Price from : <strong>£650</strong></span>,
        doubleImg: [gat1, gat2],
      },
    ],
    lastImg: gat3,
  },
  'Lighting': {
    type: 'L',
    category: false,
    price: <>Price from per Point: <strong>£200</strong></>,
    images: [lighting5, lighting1, lighting2, lighting6, lighting3, lighting4 ],
  },
  'Planting Flowers and Trees': {
    category: false,
    // price: <>Average Price per Point: <strong>£200</strong></>,
    images: [Planting11, Planting12, Planting13, Planting14, Planting15, Planting16],
    type: 'L',
  },
  'Garden Room': {
    type: 'L',
    category: false,
    price: <>Price from: <strong>£1000 per Sq.m</strong></>,
    description: <>
      <strong>Garden Rooms in London – Your Extra Space, Right Outside</strong>
      <p>Looking to add more space without moving house? A <b>garden room</b> is a smart and stylish solution. Whether you need a <b>home office</b>, a <b>studio</b>, a <b>gym</b>, or just a place to relax — our <b>garden room installations in London</b> are custom-built to fit your lifestyle and property.<br /><br /></p>

      <strong>What Is a Garden Room?</strong>
      <p>A <b>garden room</b> is a fully insulated, weatherproof building set up in your garden. It looks great, feels like part of your home, and can be used all year round. Unlike traditional extensions, garden rooms are quicker to install, don`t require major construction, and often don`t need planning permission.</p>

      <p>We build bespoke <b>garden offices, studios, guest rooms, hobby spaces,</b> and more — made to suit your needs and style.<br /><br /></p>

      <strong>When and Why Do You Need a Garden Room?</strong>
      <h4>You might consider a garden room when:</h4>
      <ul>
        <li>You`re working from home and need a quiet <b>garden office</b></li>
        <li>You want a separate <b>gym, studio,</b> or <b>creative space</b></li>
        <li>You`re running out of space indoors but don`t want to move</li>
        <li>You want to add value to your home with a functional and modern addition</li>
        <li>You need a peaceful retreat right in your garden<br /><br /></li>
      </ul>
      <p>It`s a perfect option for professionals, families, freelancers, and anyone needing <b>extra space in London</b> without the stress of a full extension.<br /><br /></p>

      <strong>What You Gain with Our Garden Room Installation</strong>
      <ul>
        <li> <b>Extra living or working space</b> – Ideal for offices, guest rooms, or hobbies</li>
        <li> <b>All-season use</b> – Fully insulated and weatherproof for year-round comfort</li>
        <li> <b>Modern, stylish design</b> – Tailored to your garden and personal taste</li>
        <li> <b>Fast, clean installation</b> – Much quicker than brick-built structures</li>
        <li> <b>Adds real value</b> – Boosts both lifestyle and property resale price</li>
        <li> <b>Private & quiet</b> – A peaceful escape just a few steps from your home<br /><br /></li>
      </ul>

      <strong>Why Choose Us?</strong>
      <p>As trusted builders of <b>bespoke garden rooms in London</b>, we offer complete service — from design to installation. <br /><br /><strong>You`ll get:</strong></p>
      <ul>
        <li>High-quality materials (timber cladding, double glazing, full insulation)</li>
        <li>Full electrical setup (lighting, sockets, heating if needed)</li>
        <li>Custom layout, flooring, finishes, and more</li>
        <li>Expert guidance on planning rules and placement<br /><br /></li>
      </ul>
      <p>We handle everything, so you can simply enjoy your new space — built to your vision and ready to use.<br /><br /></p>

      <h4>Contact us today for a free consultation and quote on your dream garden room in London!<br />
      Let`s turn your garden into something truly special — more space, more comfort, more living.<br /><br /></h4>
    </>,
    images: [summer2, summer4, summer1, summer3, Read1, Read2, Read3, room1, room2, room3, room4],
    // summer5
  },
  'Raised Beds': {
    type: 'L',
    category: true,
    categoryContent: [
      {
        title:'Rendered and Painted',
        subtitle:'Include:',
        list: ['Blocks and aggregates', 'Steel Angle Trim', 'Paint', 'Soil', 'Labour'],
        price: <span>Price from per Linear m: <strong>£280</strong></span>,
        img: raised1,
      },
      {
        title: 'Wooden Railway Sleepers Beds',
        subtitle:'Include:',
        list: ['Wooden Railway Sleeper', 'Wooden Post', 'Postfix', 'Screws', 'Soil', 'Labour'],
        price: <span>Price from per Linear m: <strong>£200</strong></span>,
        img: raised2,
      },
      {
        title: 'Blocks with Wooden Screening',
        subtitle:'Include:',
        list: ['Blocks and aggregates', 'Wooden Screening', 'Varnish', 'Soil', 'Labour'],
        price: <span>Price from per Linear m: <strong>£300</strong></span>,
        img: raised3,
      },
      {
        title: 'Integrated Sitting Area',
        subtitle:'Include:',
        list: ['Blocks and aggregates', 'Steel Angle Trim', 'Wooden Screening', 'Paint', 'Varnish', 'Labour'],
        price: <span>Price from per Linear m: <strong>£250</strong></span>,
        img: raised4,
      },
    ],
  },
  'Brickwall': {
    type: 'L',
    category: false,
    price: <>Price from per Linear m:  <strong>£700</strong></>,
    subtitle:'Included:',
    imgFirst: <img width='100%' src={brickwall1} />,
    imgSecondary: <img width='100%' src={brickwall2} />,
    imgThird: <img width='100%' src={brickwall3} />,
    imgFourth: <img width='100%' src={brickwall4} />,
    imgFifth: <img width='100%' src={brickwall5} />,
    list: [
      { title: 'EReinforced Foundation', icon: undefined },
      { title: 'Bricks', icon: undefined },
      { title: 'Mortar', icon: undefined },
      { title: 'Labour', icon: undefined },
      { title: 'Wall Height up to 1.83m (6ft)', icon: undefined },
    ],
  },
  'Landscape Architect': {
    type: 'L',
    category: false,
    images: [landscapeArch1, landscapeArch2, landscapeArch3, landscapeArch4, landscapeArch5, landscapeArch6, landscapeArch7, landscapeArch8, landscapeArch9, landscapeArch10, landscapeArchProject1, landscapeArchProject5, landscapeArchProject6, land1, land2, land3],

    imagesVertical: [land4],
    list: [
      { title: 'Estimation', icon: undefined },
      { title: 'Landscape Design', icon: undefined },
      { title: 'Sketch Images 3d', icon: undefined },
      { title: 'Plant Legend', icon: undefined },
      { title: 'Description of Works', icon: undefined },
      { title: 'Lighting plan', icon: undefined },
      { title: 'Irrigation Plan', icon: undefined },
    ],
  },
}
export const project =[
  { name: 'Woodford Green', img: Ready4 },
  { name: 'East Finchley', img: Ready1 },
  { name: 'Highgate', img: mBefore1New },
  { name: 'Crouch Hill', img: Read9 },
  { name: 'Hadley Wood', img: Ready13 },
  { name: 'Redbridge', img: Ready2 },
  { name: 'Loughton', img: Ready },
  { name: 'Planting', img: Plan },
  { name: '1 Muswell Hill', img: muswellHill1 },
  { name: 'Palmers Green', img: palmersGreen1 },
  { name: 'Muswell Hill', img: muswellHill },
  { name: 'Leinster Road Muswell Hill', img: leinsterRoad1 },
  { name: 'Highbury', img: highbury1 },
  { name: 'Hampstead Suburban Area', img: hampstead1 },
  { name: 'Hackney', img: hackney1 },
  { name: 'Belsize Park', img: belsizePark1 },
  { name: '4 Muswell Hill', img: muswellHill4_1 },
  { name: '2 Muswell Hill', img: muswellHill2_1 },
  { name: '3 Muswell Hill', img: muswellHill3_1 },
  { name: '2 Hackney', img: hackney2_1 },
]

export const initialStateGallery = { name: '' }
export const initialStateModal = { mobileMenuIsOpen: false , contactUsIsOpen: false, successModalIsOpen: false }
export const initialStateListOfJobs = { name: '', flex: 'row', about: false, open: false, activeCategory: '' }
const width = window.innerWidth
export const isMobile = width < 550

export const HOME = '/'
export const GALLERY = '/gallery'
export const JOBS = '/services'
export const CONTACT = '/contact'
export const ABOUT = '/about'

export const navLinks = [
  { name: 'home', path: '/' },
  { name: 'list of services', path: '/services' },
  { name: 'gallery', path: '/gallery' },
  { name: 'contact us', path: '/contact' },
  { name: 'about us', path: '/about' }]

export const regEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/